import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ITableService } from '../../../common/interfaces/table/table-service.interface';
import { AbstractLmtActivityService } from '../abstraction/abstract.lmt-activity.service';
import { ITableServerResponseFilter } from '../../../common/interfaces/table/table-server-filter-response.interface';
import { ITableServerFilter } from '../../../common/interfaces/table/table-server-filter.inteface';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MockLmtActivityService extends AbstractLmtActivityService {
  private tableFilterJson = 'assets/mocks/rtp/accountactivity/lmtActivity/tableFilter.json';

  tableFilter(filter: ITableServerFilter): Promise<ITableServerResponseFilter | undefined> {
    return lastValueFrom(this.http.get<ITableServerResponseFilter>(this.tableFilterJson));
  }
  tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    throw new Error('Method not implemented.');
  }
  tableExportExcel(filter: ITableServerFilter): Promise<any> {
    throw new Error('Method not implemented.');
  }

  constructor(private http: HttpClient) {
    super();
  }
}
